export default __webpack_public_path__ + "static/media/mechpart.d76cec46.obj";